<template>
  <div>
    <a-modal
      :visible="visible"
      title="功能账单"
      :footer="null"
      width="700px"
      @cancel="handleClose"
    >
      <div class="productInfor">
        <a-table
          :columns="columns"
          :data-source="data"
          :row-key="(record) => record.id"
          :pagination="false"
        >
          <!-- 表头插槽 -->
          <template slot="Title" slot-scope="text,record">
              剩余次数<a-icon class="iconStY" type="redo" @click="getList(conventionCode)"/>
             </template>
            <span slot='remainNums' slot-scope="text, record">
               <span v-if="text==0" style="color:red">{{text}}</span>
               <span style="color: #45a5e6;" v-else>{{text}}</span>
            </span>
          <span slot="operation" slot-scope="text, record">
            <a @click="openProductOrder(record)" v-if="record.isBuy">去购买</a>
            <span v-else>-</span>
          </span>
          <span slot='pendingPaymentAmount' slot-scope="text, record">
              <span v-if="text" style="color: #45a5e6;">{{text}}</span>
                <span v-else style="color: #45a5e6;">-</span>
        </span>
        </a-table>
      </div>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          display: 'flex',
          justifyContent: 'right',
          alignItems: 'center',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <span @click="BagButton"
          ><a>购物袋 （数量：{{ shoppingBagNums }}）</a></span
        >
        <span class="hhh">
          <a-button
            style="margin-left: 15px"
            type="info"
            v-if="shoppingBagNums > 0"
            @click="buy"
          >
            立即购买
          </a-button>
        </span>
        <a-button
          style="margin-left: 15px"
          type="primary"
          @click="fabu"
          :disabled="isPublish == 0"
        >
          确认发布
        </a-button>
      </div>
    </a-modal>
    <!-- 产品订购 -->
    <ProductOrderingNew
      v-if="visibleProductOrdering"
      :visible="visibleProductOrdering"
      :bagButton="true"
      :code="code"
      :conventionCode="conventionCode"
      v-on:closeProductOrdering="closeProductOrdering"
    />
    <!-- 确认产品信息 -->
    <ProductinforNew
      v-if="ProductVisible"
      :visible="ProductVisible"
      :orderNumber="orderNumber"
      v-on:closeProductinfor="closeProductinfor"
    >
    </ProductinforNew>
    <a-modal
      :visible="shopBagVisible"
      @cancel="bagClose"
      :footer="null"
      width="800px"
      title="产品清单"
    >
      <a-table
        :columns="ShopColumns"
        :data-source="dataBag.detail"
        :pagination="false"
      >
        <span slot="serviceName" slot-scope="text, record">
          <span>{{ record.serviceName }}</span>
        </span>
        <span slot="productNums" slot-scope="text, record"> x {{ text }} </span>
        <span slot="orderMoney" slot-scope="text, record">
          <span
            v-if="record.orderMoneyYj !== record.orderMoney"
            style="text-decoration: line-through; color: #c6c6c6"
            >原价{{ record.orderMoneyYj }}元</span
          >
          <span style="color: #fe6b22"> {{ record.orderMoney }}元</span>
        </span>
      
        <span slot="operation" slot-scope="text, record">
          <a-popconfirm
            title="是否确认删除?"
            ok-text="是"
            cancel-text="否"
            @confirm="del(record.id)"
          >
            <a>删除</a>
          </a-popconfirm>
        </span>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import ProductinforNew from "./ProductinforNew.vue";
import ProductOrderingNew from "@/components/PaidView/ProductOrderingNew";
import {
  getShopList,
  getOrderDetail,
  delShopList,
} from "@/service/authentication";

export default {
  name: "ShopBagList",
  components: { ProductOrderingNew, ProductinforNew },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    conventionCode: {
      type: String,
      default: "",
    },
  },
  data() {
    const ShopColumns = [
      {
        title: "产品名称",
        dataIndex: "serviceName",
        key: "serviceName",
        scopedSlots: { customRender: "serviceName" },
      },
      {
        title: "类型",
        dataIndex: "purchaseType",
        key: "purchaseType",
        align: "center",
      },
      {
        title: "单价",
        key: "price",
        align: "price",
        dataIndex: "price",
      },
      {
        title: "数量",
        key: "productNums",
        dataIndex: "productNums",
        align: "center",
        scopedSlots: { customRender: "productNums" },
      },
      {
        title: "时长",
        key: "periodOfValidity",
        align: "periodOfValidity",
        dataIndex: "periodOfValidity",
      },
      {
        title: "成交金额",
        align: "right",
        key: "orderMoney",
        dataIndex: "orderMoney",
        scopedSlots: { customRender: "orderMoney" },
      },
      {
        title: "操作",
        align: "center",
        scopedSlots: { customRender: "operation" },
      },
    ];
    return {
      visibleProductOrdering: false,
      code: "", //产品code，
      orderNumber: "",
      ProductVisible: false,
      isPublish: 0,
      data: [],
      shoppingBagNums: 0,
      columns: [
        {
          title: "产品名称",
          dataIndex: "serviceName",
          key: "serviceName",
          align: "center",
        },
        {
        
          dataIndex: "remainNums",
           key: "remainNums",
          align: "center",
          scopedSlots: { title: 'Title', customRender:'remainNums'},
        },
        {
          title: "扣除次数",
          dataIndex: "deductionNumber",
          key: "deductionNumber",
          align: "center",
        },
        {
          title: "待支付金额",
          dataIndex: "pendingPaymentAmount",
          key: "pendingPaymentAmount",
          align: "center",
            scopedSlots: {  customRender:'pendingPaymentAmount'},
        },
        {
          title: "操作",
          scopedSlots: { customRender: "operation" },
        },
      ],
      shopBagVisible: false,
      ShopColumns: ShopColumns,
      dataBag: {},
    };
  },
  created() {
    this.getList(this.conventionCode);
  },
  methods: {
    async getList(conventionCode) {
      const res = await getShopList(conventionCode);
      if (res.code == 0) {
        if (res.data.funcBilings.length !== 0) {
          (this.data = res.data.funcBilings),
            (this.shoppingBagNums = res.data.shoppingBagNums),
            (this.orderNumber = res.data.orderNumber);
          this.isPublish = res.data.isPublish;
        } else {
          this.handleClose();
          this.fabu();
        }
      }
    },
    closeProductOrdering(val) {
      this.visibleProductOrdering = val;
    },
    closeProductinfor(val) {
      this.ProductVisible = val;
    },
    openList2222() {
      this.$emit("open");
    },
    //去购买打开产品订购中心
    openProductOrder(record) {
      this.code = record.serviceCode;
      this.visibleProductOrdering = true;
    },
    // 立即购买打开产品确认信息
    buy() {
      this.ProductVisible = true;
    },
    handleClose() {
      let flag = false;
      this.$emit("closeMainShopBag", flag);
    },
    fabu() {
      this.$parent.publishMeet();
      let flag = false;
      this.$emit("closeMainShopBag", flag);
    },
    BagButton() {
      this.shopBagVisible = true;
      this.getOrder();
    },
    bagClose() {
      this.shopBagVisible = false;
      this.getList(this.conventionCode);
    },
    // 获取单个订单详情
    async getOrder() {
      const res = await getOrderDetail(this.orderNumber);
      if (res.code == 0) {
        this.dataBag = res.data;
      } else {
        this.$message.warn(res.message);
      }
    },
    async del(id) {
      const res = await delShopList(this.conventionCode, id);
      if (res.code == 0) {
        this.$message.success("删除成功!");
        this.getOrder();
      } else {
        this.$message.warn(res.message);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.productInfor {
  height: 300px;
  overflow-y: scroll;
}
.marginTopSty {
  margin-top: 30px;
}
.hhh {
  .ant-btn {
    border-color: #1890ff !important;
    color: #1890ff;
  }
}
.iconStY {
      color: #45a5e6;
      font-size: 15px;
      margin-left: 5px;
      // margin-top: 3px;
    
    }
</style>
